import { useAppSelector } from '../../../store';

export const useGetTaskAuthor = (authorId: number) => {
    const { employees } = useAppSelector((state) => state.tasksInformationReducer);
    const taskAuthor = employees.filter((item) => item.id === authorId)[0];

    if (!authorId) return { authorName: '', authorAvatar: '' };

    return { authorName: taskAuthor?.name, authorAvatar: taskAuthor?.avatar_url };
};
